import { type MouseEvent } from "react";
import { Divider, Menu, MenuItem } from "@material-ui/core";
import { useStyles } from "./custom-dropdown.styles";
import { IMenuOption } from "../../shared/components/NewMenu/useMenuOptions";
import { useHistory } from "../../shared/hooks/useHistory";

interface CustomDropdownProps {
  handleClose: () => void;
  handleClick: () => void;
  options: IMenuOption[];
  open: boolean;
  anchorEl: Element | ((element: Element) => Element);
}

type OptionClickEvent = (
  path: string
) => (event: MouseEvent<HTMLElement>) => void;

const CustomDropdown = ({
  anchorEl,
  open,
  options,
  handleClose,
  handleClick,
}: CustomDropdownProps) => {
  const classes = useStyles();
  const history = useHistory();

  const handleOptionClick: OptionClickEvent = (path: string) => () => {
    history.push(`/participant${path}`);
    handleClick();
  };

  return (
    <Menu
      id="basic-menu"
      data-testid="basic-menu"
      className={classes.dropdownMenu}
      anchorEl={anchorEl}
      open={open}
      onClose={() => handleClose()}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      {options.map((option) => (
        <div key={option.text}>
          <MenuItem
            onClick={handleOptionClick(option.path)}
            className={classes.item}
          >
            {option.Icon}
            {option.text}
          </MenuItem>
          {option.divider && <Divider variant="middle" />}
        </div>
      ))}
    </Menu>
  );
};

export default CustomDropdown;
